import { render, staticRenderFns } from "./QuestionTextArea.vue?vue&type=template&id=337708f4&scoped=true"
import script from "./QuestionTextArea.vue?vue&type=script&lang=js"
export * from "./QuestionTextArea.vue?vue&type=script&lang=js"
import style0 from "./QuestionTextArea.vue?vue&type=style&index=0&id=337708f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337708f4",
  null
  
)

export default component.exports